import React, { useEffect } from "react";

const { RuntimeLoader, useRive } = await import("@rive-app/react-canvas").then(
  (mod) => mod,
);
const riveWASMResource = await import("@rive-app/canvas/rive.wasm?url").then(
  (mod) => mod.default,
);

RuntimeLoader.setWasmUrl(riveWASMResource);

export const RiveComponent = ({
  isInView,
  url,
}: Readonly<{ isInView?: boolean; url: string }>) => {
  const { rive, RiveComponent } = useRive(
    {
      src: url,
      autoplay: false,
      artboard: "Artboard",
      automaticallyHandleEvents: true,
      isTouchScrollEnabled: true,
      stateMachines: "State Machine 1",
    },
    { shouldResizeCanvasToContainer: true },
  );

  useEffect(() => {
    if (isInView) {
      rive?.play();
    } else {
      rive?.pause();
    }
  }, [rive, isInView]);

  useEffect(() => {
    return () => {
      rive?.cleanup();
    };
  }, [rive]);

  return <RiveComponent />;
};
